module.exports = __webpack_public_path__ + "static/media/click.d0a7516e.wav";